import React, { useState } from 'react';
import FormFields from "../../../../common/components/formFields"
import { Button, Form } from 'react-bootstrap';
import { roles } from '../../../../common/utils/salesforce';
import "./heroSection.scss";

function ContactForm(props) {
  const { values, submitHandler, validated, isValid, error, setValue, setIsValid } = props;

  const [selectValue, setSelectValue] = useState(false)

  const onChange = e => {
    const { name, value } = e.target;
    
    const inputRegex = /^\s*$/;   
  
    if (e.target.tagName === 'SELECT') {
      setSelectValue(true)
    }
    if (name === 'email') {
      const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
      setIsValid(emailRegex.test(e.target.value));
    }
    if(name === 'first_name' || name === 'last_name' || name === 'brand' || name === 'Message__c'){
      if(!inputRegex.test(value)){
        setValue({ ...values, [name]: value });
      } else{
        setValue({ ...values, [name]: '' });
      }
    } else {
      setValue({ ...values, [name]: value });
    }
  }

  const inputStyle = {
    '--border-color': '#FFFFFF',
    '--color': '#FFFFFF',
  };

  return (
    <div className='contact-form-section'>
      <Form method='POST' id="leadForm2" noValidate validated={validated}
        onSubmit={submitHandler}
      >
        <FormFields
          name="first_name"
          label="First Name"
          type="text"
          value={values.first_name}
          onChange={onChange}
          placeholder="First Name"
          required
          isValid={isValid}
          maxLength={25}
          errorMessage="Please fill out this field."
          borderColor="#FFFFFF"
          backgroundColor="#1D252C"
          dashColor="#FFF200"
        />
        <FormFields
          name="last_name"
          label="Last Name"
          type="text"
          value={values.last_name}
          onChange={onChange}
          placeholder="Last Name"
          required
          isValid={isValid}
          maxLength={40}
          errorMessage="Please fill out this field."
          borderColor="#FFFFFF"
          backgroundColor="#1D252C"
          dashColor="#FFF200"
        />
        <FormFields
          name="brand"
          label="Brand"
          type="text"
          value={values.brand}
          onChange={onChange}
          placeholder="Brand"
          required
          isValid={isValid}
          maxLength={50}
          errorMessage="Please fill out this field."
          borderColor="#FFFFFF"
          backgroundColor="#1D252C"
          dashColor="#FFF200"
        />
        <FormFields
          name="email"
          label="Business Email"
          type="email"
          value={values.email}
          onChange={onChange}
          placeholder="Business Email"
          required
          isValid={isValid}
          maxLength={100}
          isInvalid={!isValid && values.email.length > 0}
          errorMessage="Please enter a valid email address"
          borderColor="#FFFFFF"
          backgroundColor="#1D252C"
          dashColor="#FFF200"
        />
        <FormFields
          name="Role__c"
          label="Role"
          type="select"
          value={values.Role__c}
          onChange={onChange}
          options={roles}
          required
          isValid={isValid}
          validated={validated}
          selectValue={selectValue}
          errorMessage="Please select a role."
          borderColor="#FFFFFF"
          backgroundColor="#1D252C"
          dashColor="#FFF200"
        />
        <FormFields
          name="Message__c"
          label="How can we support your advertising goals?"
          type="textarea"
          value={values.Message__c}
          onChange={onChange}
          placeholder=""
          required
          rows={5}
          isValid={isValid}
          maxLength={250}
          errorMessage="Please fill out this field."
          borderColor="#FFFFFF"
          backgroundColor="#1D252C"
          color="#FFFFFF"
          dashColor="#FFF200"
        />
        <div className='sumbit-btn-container'>
          <Button className='form-submitBtn' style={inputStyle} variant="outline-*" type='submit' id="btnSubmit3">Submit</Button>
        </div>
        {error && (
          <div className='form-error-container'>
            {error && <div className="article-error-msg" style={inputStyle}>{error}</div>}
            {/* {message && <div className="article-success">{message}</div>} */}
          </div>
        )}
      </Form>
    </div>
  )
}

export default ContactForm;